function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.789,49.896h39.528c1.657,0,3-1.343,3-3s-1.343-3-3-3H19.789c-1.657,0-3,1.343-3,3 S18.132,49.896,19.789,49.896"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.789,68h39.528c1.657,0,3-1.343,3-3s-1.343-3-3-3H19.789c-1.657,0-3,1.343-3,3S18.132,68,19.789,68"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.789,86.104h39.528c1.657,0,3-1.343,3-3s-1.343-3-3-3H19.789c-1.657,0-3,1.343-3,3 S18.132,86.104,19.789,86.104"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.106,0H18.001c-1.658,0-3,1.343-3,3v12H3c-1.657,0-3,1.343-3,3v94c0,1.657,1.343,3,3,3h75.106 c1.656,0,3-1.343,3-3v-12h12c1.657,0,3-1.343,3-3V3C96.106,1.343,94.763,0,93.106,0 M75.106,109H6.001V21h69.105V109z M90.106,94h-9 V18c0-1.657-1.344-3-3-3H21.001V6h69.105V94z"
});

var SvgDocumenti = function SvgDocumenti(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 97,
    height: 116,
    viewBox: "-0.014 -0.446 97 116",
    enableBackground: "new -0.014 -0.446 97 116",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocumenti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documenti.e693809a.svg";
export { ForwardRef as ReactComponent };